import { useSelector } from 'react-redux';

//@ts-ignore
import useCoreTimer from '@web-solutions/core/hooks/use-timer';
import { selectSpecialOfferEndDate } from '@web-solutions/core/store/billing/selectors';
import { formatToStringForTimer } from '@web-solutions/core/utils/format-to-string-for-timer';

export const useSpecialOfferTimer = () => {
  const date = useSelector(selectSpecialOfferEndDate);
  const { minutes, seconds } = useCoreTimer(date);

  return {
    shown: !!date,
    ended: minutes < 0 || seconds < 0,
    time: date ? `${formatToStringForTimer(minutes)}:${formatToStringForTimer(seconds)}` : '',
  };
};
